export class SignInRequest {
    userName: string;
    password: string;

    constructor(userName: string, password: string) {
        this.userName = userName;
        this.password = password;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/requests/sign-in-request.ts